/**
 * 숫자가 아닌 문자열을 제거하는 함수
 * @param {string} sourceString
 * @returns {string} [0-9]숫자가 아닌 다른 문자를 제거하고 문자열을 반환합니다.
 */
export default function removeNotNumberFromString(sourceString) {
  const RegNotNum = /[^0-9]/g;

  return sourceString.replace(RegNotNum, '');
}
